import {toRaw, unref, isRef} from 'vue'
import cloneDeep from 'lodash.clonedeep'

export function cloneSafe(value) {
  const v = isRef(value) ? unref(value) : value
  const raw = toRaw(v)

  return cloneDeep(raw)
}
